import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { MOCK_ARRAY_10 } from "../../../../lib/constants";
import { DefaultLoadingComponent } from "../../../global/defaultLoading/DefaultLoadingComponent";
import { IDrawerFiltersItems } from "../../../../interfaces/globalComponents/layout/material/NavigationDrawer/IDrawerFilters";
import { setIdFilters } from "../../../../redux/filtersSlice";
import { ClickableChip } from "../../../global/chips/ClickableChip";
import CloseIcon from "@mui/icons-material/Close";
import { useBlogNavigationContext } from "../blogTabs";

export const BlogsTopicsContent = () => {
  const allFilters = useSelector((state: RootState) => state.explore.value);
  const selectedFilters = useSelector((state: RootState) => state.filters);
  const objectives = allFilters.filtersList["objectives"] || [];
  const dispatch = useDispatch();
  const { state } = useBlogNavigationContext();

  const handleSelectObjective = (objective: IDrawerFiltersItems) => {
    dispatch(
      setIdFilters({
        id: objective.id,
        type: "objectives",
        filterFor: state.filterFor,
      }),
    );
  };

  if (objectives.length === 0) {
    return (
      <>
        {MOCK_ARRAY_10.map((index) => {
          return (
            <DefaultLoadingComponent
              className={"rounded-2xl inline-block mr-2 mb-3"}
              key={index}
              height={30}
              width={120}
            />
          );
        })}
      </>
    );
  }

  return (
    <>
      {objectives.map((objective) => {
        const selected = selectedFilters[state.filterFor].objectives.includes(
          objective.id,
        );

        return (
          <ClickableChip
            isSelected={selected}
            label={objective.title}
            key={objective.id}
            className={"mr-2 mb-3 cursor-pointer rounded-3xl lg:px-1 lg:py-4"}
            onClick={() => handleSelectObjective(objective)}
            endIcon={selected ? <CloseIcon /> : null}
          />
        );
      })}
    </>
  );
};
